<template>
  <div>
    <!-- <LayoutNav></LayoutNav> -->
    <shop-head currentPageName="HOME"></shop-head>

    <div class=" pr-28">
      <!-- bannerTop -->
      <div class="slider_area-3 ">
        <div class="container ">
          <div class="top_home ">
            <el-row type="flex" style="flex-wrap: wrap;">
              <el-col :span="5" class="d-none d-lg-block  "></el-col>
              <el-col :span="19" class="">
                <el-row :gutter="10" class="" type="flex" justify="center" style="flex-wrap: wrap;height: 400px;">
                  <!-- 轮播图 -->
                  <el-col :md="18" :sm="18" class="">
                    <div class="shop-banner_area ">
                      <div class="home-banner ">
                        <el-carousel height="492px" indicator-position="inside">
                          <el-carousel-item v-for="item in bannerList" :key="item.id">
                            <!-- <img :src="item.image ? 'https://' + item.image : ''" alt="" />  image.startsWith('https://') ? iamge: 'https://'+iamge-->
                            <img :src="item.image.startsWith('https://') ? item.image : 'https://' + item.image"
                              alt="" />
                          </el-carousel-item>
                        </el-carousel>
                      </div>

                    </div>
                  </el-col>

                  <el-col class="" :md="6" :sm="6" :xs="24">
                    <div class="shop-banner_area scale box_shadow  " style="padding:10px">
                      <div class="img-hover_effect ">
                        <div class="user-meta ">
                          <div class="avatar ">
                            <img
                              :src="user.headImgurl || 'http://yjy-xiaotuxian-dev.oss-cn-beijing.aliyuncs.com/picture/2021-04-15/e83efb1b-309c-46f7-98a3-f1fefa694338.jpg'" />
                          </div>
                          <div class="fw-6 ml-10 flex-col  fs-12 user_Info">
                            <div>{{ user.nickname || '' }} HI~ <span>下午好！</span></div>
                            <div class="u_text fs-10  ">{{ $t('欢迎来到广园汇汽配港!') }}</div>
                          </div>
                        </div>
                      </div>
                      <!-- 登录按钮 -->
                      <div class="mt-10 flex-row flex-row-around-c mb-15 ">
                        <el-button v-if="!user.nickname" size="mini" style="width: 96px;" type="primary"
                          @click="login">{{ $t('登录') }}</el-button>
                        <el-button v-else size="mini" type="danger" style="width: 160px;" @click="logout">{{ $t('退出登录')
                        }}</el-button>
                        <el-button v-if="!user.nickname" size="mini" type="success" @click="register">{{ $t('免费注册')
                        }}</el-button>
                      </div>
                      <div style="border: 1px dotted  #c8c8c8;"></div>
                      <!-- 资讯类 -->
                      <div class="flex-row flex-row-between mt-10">
                        <h5 class="fw-b">{{ $t('新闻') }}</h5>
                        <router-link to="/qpgtt">
                          <span style="color: #c3c3c3;" class="fs-10">{{ $t('更多') }}</span>
                        </router-link>
                      </div>
                      <!-- 内容 -->
                      <div class="newList">
                        <ul class="custom-list fs-10" v-for="(item, index) in NewsList" :key="index">
                          <li @click="goDetail(item)"> <a>{{ item.name }}</a></li>
                        </ul>
                      </div>
                      <!-- 图片 -->
                      <div class="imgList  flex-row  mt-20 ml-10">
                        <div><img src="../../assets/images/erweima2.png" alt=""></div>
                        <div><img src="../../assets/images/erweima.jpg" alt=""></div>
                      </div>
                      <div class="p-10 fs-12 b_text" style="color: #c3c3c3;text-align: center;">{{ $t('扫一扫关注官方公众号和小程序')
                      }}</div>

                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 商品 -->
      <!-- <div v-for="(item, index) in goodsList" :key="index">
          <goods :title="item.title" :goodsList="item.goodsList" :menuList="item.menuList"></goods>
        </div> -->

      <!-- 实力工厂 -->
      <div class="shipping-nav ">
        <div class="container ">
          <div class=" shipping-box ">
            <el-row class="" type="flex" style="align-items: self-start;margin-bottom: 20px;" justify="space-between">
              <el-col :md="4" :sm="4">
                <div class="title fw-6 fs-20">{{ $t('实力工厂') }}</div>
              </el-col>
              <el-col :md="18" :sm="18" class="itemTitle fw-9 ">
                <ul>
                  <li v-for="(item, index) in FactoryMenu" :key="index" to="" @click="selectItem(index, item)"
                    :class="{ 'selected': selectedIndex === index }">
                    {{ lang == 'zh' ? item.note : item.keyS }}
                  </li>
                </ul>
              </el-col>
              <el-col :md="2" :sm="2" class="fs-14 flex-row flex-row-e-c ">
                <router-link to="/company">
                  <div class="more">{{ $t('查看更多') }}</div>
                </router-link>
              </el-col>
            </el-row>
            <goods :bannerImg="require(`@/assets/images/fac_porwer.png`)" :goodsList="FactoryList" :title="$t('实力工厂')"
              :title_img="require(`@/assets/images/deflault_load.png`)" :type=1></goods>
          </div>
        </div>
      </div>

      <!-- 品牌 -->
      <div class="brandList">
        <div class="container">
          <div class="brand-box ">
            <el-row class="" type="flex" style="align-items: self-start;margin-bottom: 20px;" justify="space-between">
              <el-col :md="4" :sm="4">
                <div class="title fw-6 fs-20">{{ $t('优秀品牌') }}</div>
              </el-col>
              <el-col :md="14" :sm="14" class="itemTitle fw-9">
              </el-col>
              <el-col :md="6" :sm="6" class="fs-14 flex-row flex-row-e-c ">
                <router-link to="/shop">
                  <div class="more">{{ $t('查看更多') }}</div>
                </router-link>
              </el-col>
            </el-row>
            <!-- 内容 -->
            <div class="brand_main">
              <el-row class="el-row ">
                <el-col style="width: 180px" class="">
                  <div class="brandImg floating-image flex-col">
                    <img style="width: 100%; 
                      height: 80% ;
                      object-fit: fill;" :src="require(`@/assets/images/brand_good.png`)">
                    <div class="flex-row icon_bot">
                      <div class="b_title "><img class="" :src="require(`@/assets/images/deflault_load.png`)"
                          style="object-fit: contain;"></img> </div>
                      <div :class="lang == 'zh' ? 'b_textCH fs-18 ml-5' : 'b_textEG fs-18 ml-5'">
                        <div>{{ $t('优秀品牌') }}</div>
                      </div>
                    </div>

                  </div>
                </el-col>
                <el-col style="width: 320px" class="ml-20">
                  <div class="p_Img floating-image ">
                    <img class="" style="width: 90%; height: 90% ;object-fit: contain;" :src="BrandList[0].logo"></img>
                    <div class="fs-13 fw-b">{{ BrandList[0].cname }}</div>
                  </div>
                </el-col>
                <el-col style="width: 717px;  height: 100%;" :span="12" class=" ml-5">
                  <el-row style="height: 50%; padding: 10px; margin: 0; padding: 0;flex-wrap: wrap;" type="flex">
                    <el-col class="mb-6  col_item pl-10" :span="8" v-for="(item, index) in BrandList.slice(1, 7)"
                      :key="index">
                      <div class="p_Img  floating-image ">
                        <img style="width: 80%; height: 80% ;object-fit: fill;" :src="item.logo"></img>
                        <div class="fs-13 fw-b ">{{ item.cname }}</div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>


              </el-row>
            </div>
          </div>
        </div>
      </div>



      <!-- 优选产品 -->
      <div class="commodityList ">
        <div class="container ">
          <div class="commodity-box">
            <el-row type="flex" style="align-items: self-start;margin-bottom: 20px;" justify="space-between"
              class="mt-20">
              <el-col :md="4" :sm="4">
                <div class="title fw-6 fs-20">{{ $t('优秀产品') }}</div>
              </el-col>
              <el-col :md="14" :sm="14" class="itemTitle fw-9">

              </el-col>
              <el-col :md="6" :sm="6" class="fs-14 flex-row flex-row-e-c ">
                <router-link to="/shop">
                  <div class="more">{{ $t('查看更多') }}</div>
                </router-link>
              </el-col>
            </el-row>
            <div style="background-color: white;">
              <goods v-for="(item, index) in ProductsList" :key="index" :bannerImg="item.logo"
                :goodsList="item.children" :title="item.name"
                :customStyle="{ height: '67% !important', width: '69% !important' }" :type=0></goods>
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
    <el-dialog :visible.sync="showDetail" width="80%">
      <quick-view ref="quickView"></quick-view>
    </el-dialog>
  </div>
</template>

<script>
import quickView from "../../components/shop/quickView";
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import swiper from "../../components/shop/swiper";
import LayoutNav from "../../components/shop/LayoutNav";
import goods from "../..//components/shop/goods";
import {
  getBanner,
  getFactory,
  getBrandList,
  getProducts,
  getNewsList,
  getSearch,
  getheadList,
  getmap,
} from "../../apis/home";
import { loginInfo } from "../../apis/user";

export default {
  components: {
    quickView,
    shopHead,
    commonFooter,
    swiper,
    LayoutNav,
    goods,
  },
  data() {
    return {
      selectedIndex: 0,
      showDetail: false,
      user: {},
      carList: [],
      partTab: [
        {
          name: "Oil Filters",
          children: [],
        },
        {
          name: "Air Filters",
          children: [],
        },
        {
          name: "Ignition Coils",
          children: [],
        },
      ],
      partTabIndex: 0,
      partSeries: [
        {
          title: "Other Auto Steering Parts",
          children: [],
        },
        {
          title: "Radiators",
          children: [],
        },
        {
          title: "Brake Discs",
          children: [],
        },
      ],
      imgList: [
        require("../../assets/images/partIcon01.png"),
        require("../../assets/images/partIcon02.png"),
        require("../../assets/images/partIcon03.png"),
        require("../../assets/images/partIcon04.png"),
        require("../../assets/images/partIcon05.png"),
        require("../../assets/images/partIcon06.png"),
      ],
      discountList: [],
      isDiscount: false,
      sellHighe: "500px",
      timer: null,
      countTimeData: {
        Days: "00",
        Hrs: "00",
        Mins: "00",
        Secs: "00",
      },

      // 首页信息
      bannerList: [
        {
          image:
            "aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyhee66721db1e44052b988d2dd9d2f1d1dbanner-default.png",
        },
        {
          image:
            "aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyhee66721db1e44052b988d2dd9d2f1d1dbanner-default.png",
        },
      ],

      FactoryList: [
        {
          title: "广东宝勒博汽车零部件有限公司",
          img: [
            "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh22206f8e3390479cb8f1dd51475774cf宝勒博.jpg",
          ],
        },
        {
          title: "广州市凯伦格汽车零部件有限公司",
          img: [
            "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh22206f8e3390479cb8f1dd51475774cf宝勒博.jpg",
          ],
        },
      ],

      BrandList: [
        [
          {
            cname: "威迪欧",
            logo: require("../../assets/images/partIcon01.png"),
          },
          {
            cname: "倍适登",
            logo: require("../../assets/images/partIcon01.png"),
          },
        ],
        [
          {
            cname: "博世",
            logo: require("../../assets/images/partIcon01.png"),
          },
          {
            cname: "采埃孚",
            logo: require("../../assets/images/partIcon01.png"),
          },
          {
            cname: "岱高",
            logo: require("../../assets/images/partIcon01.png"),
          },
          {
            cname: "德尔福",
            logo: require("../../assets/images/partIcon01.png"),
          },
          {
            cname: "法雷奥",
            logo: require("../../assets/images/partIcon01.png"),
          },
          {
            cname: "海拉",
            logo: require("../../assets/images/partIcon01.png"),
          },
        ],
      ],
      ProductsList: [
        {
          name: "底盘系列",
          children: [
            {
              img: [
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-2.png"),
              ],
            },
          ],
        },
        {
          name: "汽车养护",
          children: [
            {
              img: [
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
              ],
            },
            {
              img: [
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
              ],
            },
            {
              img: [
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
              ],
            },
            {
              img: [
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
              ],
            },
            {
              img: [
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
              ],
            },
          ],
        },
        {
          name: "车身系列",
          children: [
            {
              img: [
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
              ],
            },
          ],
        },
        {
          name: "发动机系列",
          children: [
            {
              img: [
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
                require("../../assets/images/product/product01-1.png"),
              ],
            },
          ],
        },
      ],
      categoryList: [],

      NewsList: [],
      SearchList: [],
      FactoryLogo: require("../../assets/images/product/product01-1.png"),
      FactoryMenu: [],
      lang: "",
    };
  },
  watch: {
    showDetail(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs.quickView.resetData();
        });
      }
    },
  },
  created() {
    this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
    this.loginInfo();
  },
  mounted() {
    this.getDataList();
    this.getproduct();
    this.getBandList();
    this.getFactoryList("汽车养护系列");
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWindow);
    clearInterval(this.timer);
  },
  methods: {
    async getDataList() {
      try {
        const bannerList = await getBanner();
        const NewsList = await getNewsList();
        this.bannerList = bannerList.data;
        this.NewsList = NewsList.data;
      } catch (e) {
        this.$message.error(e.message);
      }
    },

    // 单独获取优秀产品
    async getproduct() {
      try {
        // 产品数据
        const ProductsList = await getProducts();
        //logo
        const logoMap = await getmap();
        this.ProductsList = this.handleProDataList(ProductsList.data, logoMap);
        // console.log(this.ProductsList)

        // 产品logo图
        // const logoMap = await getmap();
        // console.log(logoMap)
        // const key = '发动机';
        // const  a  = logoMap.data[key].remark
        // console.log(a)

        // 实例工厂菜单
        const headList = await getheadList();
        this.FactoryMenu = headList.data;
      } catch (e) {
        this.$message.error(e.message);
      }
    },

    // 单独获取优秀品牌
    async getBandList() {
      try {
        const BrandList = await getBrandList();
        console.log(BrandList.data)
        this.BrandList = BrandList.data;
        // this.BrandList = this.handleDataBaner(BrandList.data);
      } catch (e) {
        this.$message.error(e.message);
      }
    },

    // 单独获取实例工厂数据
    async getFactoryList(category) {
      try {
        const FactoryList = await getFactory(category);
        this.FactoryList = this.goodsList(
          FactoryList.data,
          "facadePic",
          "companyName"
        );
        // this.FactoryLogo = this.FactoryList[0].logo
        this.FactoryLogo =
          this.FactoryList[0] != undefined ? this.FactoryList[0].logo : "";
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    goDetail(data) {
      this.$router.push({
        path: "/newsDetail",
        query: data,
      });
    },
    login() {
      this.$router.push({
        path: "/login",
      });
    },
    register() {
      this.$router.push({
        path: "/register",
      });
    },
    logout() {
      this.$confirm(this.$i18n.t("是否退出登录?"), this.$i18n.t("提示"), {
        confirmButtonText: this.$i18n.t("确定"),
        cancelButtonText: this.$i18n.t("取消"),
        type: "warning",
      }).then(() => {
        localStorage.removeItem("token");
        this.$router
          .replace({
            path: "/login",
          })
          .then(() => {
            window.location.reload();
          });
        this.$message({
          type: "success",
          message: this.$i18n.t("退出登录成功!"),
        });
      });
    },
    async loginInfo() {
      try {
        // 个人信息
        const res = await loginInfo();
        this.user = res.data || {};
        localStorage.setItem('userInfo', JSON.stringify(this.user))
      } catch (err) {
        console.log(err);
      }
    },

    countTime() {
      //获取当前时间
      let date = new Date();
      let now = date.getTime();

      //设置截止时间
      let tomorrow = now + 1000 * 60 * 60 * 24;
      tomorrow = new Date(tomorrow);
      let str = `${tomorrow.getFullYear()}/${tomorrow.getMonth() + 1
        }/${tomorrow.getDate()} 00:00:00`;
      let endDate = new Date(str);
      let end = endDate.getTime();
      //时间差
      let leftTime = end - now;
      //定义变量 d,h,m,s保存倒计时的时间
      let d, h, m, s;
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        m = Math.floor((leftTime / 1000 / 60) % 60);
        s = Math.floor((leftTime / 1000) % 60);
      } else {
        clearInterval(this.timer);
        return;
      }
      //将0-9的数字前面加上0，例1变为01
      this.countTimeData = {
        Days: d < 10 ? "0" + d : d,
        Hrs: h < 10 ? "0" + h : h,
        Mins: m < 10 ? "0" + m : m,
        Secs: s < 10 ? "0" + s : s,
      };
      //递归每秒调用countTime方法，显示动态时间效果
      this.timer = setTimeout(this.countTime, 1000);
    },

    selectItem(index, data) {
      this.getFactoryList(data.note);
      this.selectedIndex = index;
    },

    // 品牌数据处理
    handleDataBaner(data) {
      // 创建一个包含前两个元素的子数组
      let firstSubArray = data.slice(0, 2);
      // 创建一个包含剩余元素的子数组
      let secondSubArray = data.slice(2, 8);
      return [firstSubArray, secondSubArray];
    },
    // 产品数据分离
    handleProDataList(data, logoMap) {
      // 获取产品接口
      const result = Object.keys(data).map((key) => ({
        name: key,
        children: data[key],
      }));
      // 获取产品数据处理
      const a = result.map((item) => {

        if (this.lang == 'zh') {
          item.children = this.goodsList(item.children, "picture", "cname");
        } else if (this.lang == 'en') {
          item.children = this.goodsList(item.children, "picture", "ename");
        }

        item.logo = logoMap.data[item.name].remark;
        return item;
      });
      // 实力工厂数据处理
      // this.getFactoryList(result[0].name)

      return a;
    },

    // goods组件数据处理
    goodsList(data, imgkey, title = "") {
      const result = data.map((item) => {
        const newItem = { ...item };
        newItem.img = item[imgkey].split(",");
        newItem.title = title ? item[title] : "";
        return newItem;
      });
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.top_home {
  width: 1200px;

  /** banner */
  .shop-banner_area {
    width: 100%;
    height: 492px;
    // padding: 20px 20px;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .img-hover_effect {
      .user-meta {
        display: flex;
        justify-content: flex-start !important;
        height: 44px;
        width: 100%;

        .avatar {
          width: 30%;
          height: 100%;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .user_Info {
          width: 100%;
          justify-items: center;
          justify-content: center;
          flex-wrap: nowrap;
        }

        .u_text {
          color: #8c8c8c;
          line-height: 13px;
        }
      }
    }

    &.scale:hover {
      .img-hover_effect {
        img {
          transform: scale(1.06);
          transition: all 0.3s ease-in;
        }
      }
    }

    .newList {
      width: 100%;

      .custom-list {
        list-style: none;
        /* 去除圆点或数字 */
        padding: 0;
        /* 去除内边距 */
        margin: 0;

        /* 去除外边距 */
        li {
          padding: 5px 0;
          /* 添加适当的内边距 */
          font-size: 13px;
          /* 自定义字体大小 */
          color: #333;
          /* 自定义文本颜色 */
          line-height: 2;
          /* 行高，改善可读性 */
          white-space: nowrap;
          /* 不允许换行 */
          overflow: hidden;
          /* 隐藏超出容器的部分 */
          text-overflow: ellipsis;

          /* 超出部分显示省略号 */
          a {
            color: #333;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .imgList {
      width: 100%;

      img {
        width: 90px;
        height: 90px;
      }
    }

    .b_text {
      line-height: 13px;
    }
  }
}

.slider_area-3 {
  // background-color: #ffffff;
  height: 480px;
}

.shipping_area {
  padding-bottom: 60px;

  .icon-box {
    width: 100%;
    height: auto;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    border: 1px solid #f4f4f4;
    padding: 40px 36px;

    .icon-box-item {
      max-width: 33.33%;
      line-height: 20px;
      font-size: 16px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 5px;

      img {
        flex: 0 0 40px;
        width: 40px;
        height: 40px;
      }

      .icon-box-text {
        flex: 1;
        padding-left: 5px;
        word-break: break-all;
      }
    }

    @media only screen and (max-width: 767px) {
      align-items: flex-start;
      padding: 20px 15px;

      .icon-box-item {
        display: inline-block;

        img {
          flex: unset;
          margin: 0 auto;
          display: block;
        }

        .icon-box-text {
          flex: unset;
          padding-left: 0;
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}

.home-banner {
  height: 100%;

  img {
    height: 100%;
    width: 100%;
  }
}

.brandList {
  .brand-box {
    width: 1200px;
    height: auto;
    /* border: 1px solid #ebebeb; */
    padding: 30px 0 25px;

    .brand_main {
      width: 100%;
      height: 296px;
    }

    .el-row {
      display: flex;
      width: 100%;
      height: 100%;

      .title {
        border-left: #24a2ff 4px solid;
        padding-left: 10px;
      }

      .brandImg,
      .p_Img {
        text-align: center;
        width: 100%;
        height: 100%;
        object-fit: contain;
        overflow: hidden;
        background-color: white;
      }

      .brandImg {
        .icon_bot {
          width: 100%;
          height: 20%;

          .b_title {
            width: 80px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .b_textCH {
            width: 100%;
            color: #24a2ff;
            font-weight: bolder;
            height: 100%;
            justify-content: center;
            align-items: center;
            display: flex;
            align-items: center;
          }

          .b_textEG {
            width: 100%;
            color: #24a2ff;
            font-weight: bolder;
            height: 100%;
            align-items: center;
            display: flex;
            text-align: left;
          }
        }
      }

      .col_item {
        height: 98%;
      }
    }

    // .brandInfo{
    //   height: 300px;
    //   width: 100%;
    //   .brandTitle{
    //     width: 20%;
    //     height: 100%;
    //   }
    //   .brandInfo{
    //     width: 30%;
    //     height: 100%;
    //   }
    //   .brandList{
    //     width: 50%;
    //     height: 100%;
    //   }
    //   .brandImg,
    //   .p_Img {
    //     text-align: center;
    //     width: 100%;
    //     height: 100%;
    //     object-fit: contain;
    //     overflow: hidden;
    //   }
    // }
  }
}

.commodityList {
  .commodity-box {
    width: 1200px;

    .title {
      border-left: #24a2ff 4px solid;
      padding-left: 10px;
    }
  }
}

.shipping-nav {
  min-height: 253px !important;

  .shipping-box {
    width: 100%;
    height: auto;
    /* border: 1px solid #ebebeb; */
    padding: 30px 0 25px;

    .title {
      border-left: #24a2ff 4px solid;
      padding-left: 10px;
    }

    .itemTitle {
      width: 100%;
      line-height: 28px;

      ul {
        li {
          display: inline-block;
          padding-right: 20px;
          cursor: pointer;
        }
      }
    }

    .el-col {
      display: flex;
      align-items: center;

      .shipping-icon {
        height: 100%;
        width: 100%;
        text-align: center;

        .imgTitle {
          height: 100%;
          width: 100%;
          background-repeat: no-repeat;
          background-size: contain;
        }
      }

      .shipping-text {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        background: white;

        .swiper-slide {
          margin: 0 !important;

          /* 商品样式 */
          .swiper-img {
            position: relative;
            width: 170px;
            height: 190px;
            margin: 10px auto;
          }

          .protitle {
            text-align: center;
          }
        }
      }
    }

    /* @media only screen and (max-width: 991px) {
      padding: 30px 30px 25px;
    }
    @media only screen and (max-width: 767px) {
      .el-col {
        display: unset;
        .shipping-icon {
          flex: unset;
          width: 60px;
          margin: 0 auto;
        }
        .shipping-text {
          flex: unset;
          width: 100%;
          text-align: center;
        }
      }
    } */
    .selected {
      color: #409eff;
    }
  }
}

.floating-image {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* 添加过渡效果 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  /* 阴影效果 */
}

/* 鼠标悬停时的浮空效果 */
// .floating-image:hover {
//   transform: translateY(-10px);
//   /* 向上移动10px */
//   box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
//   /* 加强阴影 */
// }

.floating-image1 {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* 添加过渡效果 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  /* 阴影效果 */
}

.img_goods {
  height: 67% !important;
  width: 69% !important;
}
</style>
